import React from 'react'

const FormContainer = (props) => {
  return(
    <div className="form-container">
      {props.children}
    </div>
  )
}

export default FormContainer



// WEBPACK FOOTER //
// ./src/components/FormContainer.js